import React from 'react'
import './CodeBlock.css'
import { CopyBlock, dracula } from 'react-code-blocks';

function CodeBlock({body, response, displayres, text}) {
    
    return (
        <div id='codeblock'>
            <div className='codeblock_header'>
                <h1>{text}</h1>
            </div>
            <div className='codeblock_container'>
                <CopyBlock
                    text={body}
                    language="javascript"
                    showLineNumbers={false}
                    theme={dracula}
                    wrapLongLines={true}
                />
                {displayres ? 
                <CopyBlock
                    text={response}
                    language="javascript"
                    showLineNumbers={false}
                    theme={dracula}
                    wrapLongLines={true}
                /> :
                null
                }
            </div>
        </div>
    )
}

export default CodeBlock
